import React, { useEffect, useState } from 'react'
import { connect, useSelector } from 'react-redux'
import { assignDevices } from '../../store/action/device.action'
import { Checkbox, Button, Row, Col, Popover, Card, List, Modal } from 'antd'
import { EditOutlined, PlusCircleFilled } from '@ant-design/icons'
import serviceInterface from '../../services/service.interface'
import '../../css/regimen.scss'
import moment from 'moment'
const AddDevice = (props) => {
  const [open, setOpen] = useState(false)

  const hide = () => {
    setOpen(false)
  }

  const handleOpenChange = (newOpen) => {
    setOpen(newOpen)
  }

  var handleRowSelect = (selectedDevice) => {
    selectedDevice.scheduled_criteria.skiponsurgerydate=true;
    //check if start date is same or after today
    let isValidDate = moment(props.surgeryDate).add(
      selectedDevice.scheduled_criteria.start_date,'days').isSameOrAfter(moment())
    //if not then update start date with today 
    if (!isValidDate) selectedDevice.scheduled_criteria.start_date = moment()
      .startOf('day')
      .diff(moment(props.surgeryDate).startOf('day'), 'days')

    console.log('testdev567', isValidDate,typeof selectedDevice.scheduled_criteria.start_date, props.surgeryDate, moment().add(-20,'days'), moment(props.surgeryDate).add(
      selectedDevice.scheduled_criteria.start_date,'days').format('MM/DD/YYYY'))

    const devices = serviceInterface
      .DeviceService()
      .assignDevice([...props.assignedDevices], {
        ...selectedDevice,
        isNew: true,
      })
    props.assignDevices(devices)
    if (props.isEdited) props.isEdited()
    setOpen(false)
  }

  const node = (
    <Card
      className='regContainer'
      style={{
        height: '200px',
        overflow: 'auto',
        width: 'maxContent',
      }}
    >
      {props.devices
        ?.sort((a, b) => (a?.display_name > b?.display_name ? 1 : -1))
        .map((dev, i) => {
          return props.assignedDevices
            ?.map((item) => item?.display_name)
            .includes(dev?.display_name) ? null : (
            <Row className={'exerRow'}>
              <Col style={{ width: '100%' }}>
                <Row
                  className='exerSubheader divider'
                  onClick={() => handleRowSelect(dev)}
                >
                  <Col flex={'90%'}>{dev?.display_name}</Col>
                  <Col flex={'10%'}>
                    <PlusCircleFilled />
                  </Col>
                </Row>
              </Col>
            </Row>
          )
        })}
    </Card>
  )

  return (
    <Popover
      content={node}
      title='Add Device'
      trigger='click'
      placement='bottom'
      overlayStyle={{
        minWidth: '100px',
      }}
      // open={open}
      // onOpenChange={handleOpenChange}
      visible={open}
      onVisibleChange={handleOpenChange}
    >
      <Button
        id={'adddevice'}
        style={{ margin: '10px' }}
        className='nextBtn'
        type='primary'
      >
        Add Devices
      </Button>
    </Popover>
  )
}

export default AddDevice
